export default "__VITE_ASSET__Cpbk$6dA__"